// AboutTab.js
import React, {
  forwardRef,
  Fragment,
  useEffect,
  useImperativeHandle,
} from "react";
import { Grid, Box, Typography, Card, CardContent } from "@mui/material";
import { connect } from "react-redux";
import {
  getAssessmentUserDetails,
  modelToggle,
  showDetail,
  userProfileModalToggle,
} from "../../../redux/action/user";
import { IconPath } from "../../../constants/IconPath";

const AboutTab = forwardRef((props, ref) => {
  const userProfile = props.userProfile;
  const userData = props.userData;

  useEffect(() => {
    if (localStorage.getItem("userAssessmentId")) {
      props.getAssessmentUserDetails(localStorage.getItem("userAssessmentId"));
    }
  }, []);

  useImperativeHandle(ref, () => ({
    handleBackButton: () => props.showDetail(false),
  }));

  const UserDetailsRow = ({ icon, label, value }) => (
    <CardContent sx={{ borderBottom: "1px solid #263234" }}>
      <Grid container>
        <Grid item xs={4}>
          <Box
            gap={1}
            sx={{
              color: "#000",
              display: "flex",
              alignItems: "center",
              alignContent: 'center'
            }}
          >
            <Box component="span" display="flex" alignItems="center">
              {icon}
            </Box>
            <Box component="span">{label}</Box>
          </Box>

        </Grid>
        <Grid item xs={8}>
          <Box sx={{ color: "#000", textTransform: label !== "Email" ? "capitalize" : "" }}>{value}</Box>
        </Grid>
      </Grid>
    </CardContent>
  );

  const UserAssessmentRow = ({ icon, label, id }) => (
    <CardContent sx={{ borderBottom: "1px solid #263234" }}>
      <Grid container>
        <Grid item xs={6}>
          <Box display="flex" gap={1} sx={{ color: "#000" }}>
            {icon && <div>{icon}</div>}
            <Box
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
                "&:hover": {
                  color: "#FAAA2F",
                },
              }}
              onClick={() =>
                props.setActiveAboutInfo(
                  id === "view" ? "viewData" : "payHistory"
                )
              }
            >
              {label}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </CardContent>
  );

  const userFields = [
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.67998 13.46 7.97998 11.69 7.97998 9.50998C7.97998 7.28998 9.78998 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.46998 8.10998 9.46998 9.49998C9.46998 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z"
            fill="#727A7B"
          />
          <path
            d="M12 22.7498C9.30996 22.7498 6.73996 21.7498 4.74996 19.9298C4.56996 19.7698 4.48996 19.5298 4.50996 19.2998C4.63996 18.1098 5.37996 16.9998 6.60996 16.1798C9.58996 14.1998 14.42 14.1998 17.39 16.1798C18.62 17.0098 19.36 18.1098 19.49 19.2998C19.52 19.5398 19.43 19.7698 19.25 19.9298C17.26 21.7498 14.69 22.7498 12 22.7498ZM6.07996 19.0998C7.73996 20.4898 9.82996 21.2498 12 21.2498C14.17 21.2498 16.26 20.4898 17.92 19.0998C17.74 18.4898 17.26 17.8998 16.55 17.4198C14.09 15.7798 9.91996 15.7798 7.43996 17.4198C6.72996 17.8998 6.25996 18.4898 6.07996 19.0998Z"
            fill="#727A7B"
          />
          <path
            d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
            fill="#727A7B"
          />
        </svg>
      ),
      label: "Full Name",
      value: `${props.userAssessmentDetails?.Fname}  ${props.userAssessmentDetails?.Lname}`,
    },
    {
      icon: <IconPath.EMail style={{ color: '#727A7B' }} />,
      label: "Email",
      value: props.userAssessmentDetails?.EmailID,
    },
  ];

  const adminFields = [
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.67998 13.46 7.97998 11.69 7.97998 9.50998C7.97998 7.28998 9.78998 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.46998 8.10998 9.46998 9.49998C9.46998 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z"
            fill="#727A7B"
          />
          <path
            d="M12 22.7498C9.30996 22.7498 6.73996 21.7498 4.74996 19.9298C4.56996 19.7698 4.48996 19.5298 4.50996 19.2998C4.63996 18.1098 5.37996 16.9998 6.60996 16.1798C9.58996 14.1998 14.42 14.1998 17.39 16.1798C18.62 17.0098 19.36 18.1098 19.49 19.2998C19.52 19.5398 19.43 19.7698 19.25 19.9298C17.26 21.7498 14.69 22.7498 12 22.7498ZM6.07996 19.0998C7.73996 20.4898 9.82996 21.2498 12 21.2498C14.17 21.2498 16.26 20.4898 17.92 19.0998C17.74 18.4898 17.26 17.8998 16.55 17.4198C14.09 15.7798 9.91996 15.7798 7.43996 17.4198C6.72996 17.8998 6.25996 18.4898 6.07996 19.0998Z"
            fill="#727A7B"
          />
          <path
            d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
            fill="#727A7B"
          />
        </svg>
      ),
      label: "USER NAME",
      value: props?.data?.contentUser?.Fullname,
    },
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2V5"
            stroke="#727A7B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16 2V5"
            stroke="#727A7B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 9.08984H20.5"
            stroke="#727A7B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 19C22 19.75 21.79 20.46 21.42 21.06C20.73 22.22 19.46 23 18 23C16.99 23 16.07 22.63 15.37 22C15.06 21.74 14.79 21.42 14.58 21.06C14.21 20.46 14 19.75 14 19C14 16.79 15.79 15 18 15C19.2 15 20.27 15.53 21 16.36C21.62 17.07 22 17.99 22 19Z"
            stroke="#727A7B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M16.4399 19L17.4299 19.99L19.5599 18.02"
            stroke="#727A7B"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M3 13.1V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5V16.36C20.27 15.53 19.2 15 18 15C15.79 15 14 16.79 14 19C14 19.75 14.21 20.46 14.58 21.06C14.79 21.42 15.06 21.74 15.37 22H8C4.5 22 3 20 3 17"
            stroke="#727A7B"
            stroke-width="1.5"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M11.9955 13.7002H12.0045"
            stroke="#727A7B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29431 13.7002H8.30329"
            stroke="#727A7B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8.29431 16.7002H8.30329"
            stroke="#727A7B"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      label: "DATE OF BIRTH",
      value: props?.data?.contentUserProfile?.BirthDate
        ? props?.data?.contentUserProfile?.BirthDate
        : "",
    },
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 16.75C11.6 16.75 11.2 16.72 10.82 16.65C8.7 16.34 6.77 15.12 5.55 13.31C4.7 12.03 4.25 10.54 4.25 9C4.25 4.73 7.73 1.25 12 1.25C16.27 1.25 19.75 4.73 19.75 9C19.75 10.54 19.3 12.03 18.45 13.31C17.22 15.13 15.29 16.34 13.15 16.66C12.8 16.72 12.4 16.75 12 16.75ZM12 2.75C8.55 2.75 5.75 5.55 5.75 9C5.75 10.25 6.11 11.45 6.79 12.47C7.78 13.93 9.33 14.91 11.05 15.16C11.69 15.27 12.32 15.27 12.91 15.16C14.66 14.91 16.21 13.92 17.2 12.46C17.88 11.44 18.24 10.24 18.24 8.98999C18.25 5.54999 15.45 2.75 12 2.75Z"
            fill="#727A7B"
          />
          <path
            d="M6.46982 22.59C6.32982 22.59 6.19982 22.57 6.05982 22.54C5.40982 22.39 4.90982 21.89 4.75982 21.24L4.40982 19.77C4.38982 19.68 4.31982 19.61 4.21982 19.58L2.56982 19.19C1.94982 19.04 1.45982 18.58 1.28982 17.97C1.11982 17.36 1.28982 16.7 1.73982 16.25L5.63982 12.35C5.79982 12.19 6.01982 12.11 6.23982 12.13C6.45982 12.15 6.65982 12.27 6.78982 12.46C7.77982 13.92 9.32982 14.91 11.0598 15.16C11.6998 15.27 12.3298 15.27 12.9198 15.16C14.6698 14.91 16.2198 13.92 17.2098 12.46C17.3298 12.27 17.5398 12.15 17.7598 12.13C17.9798 12.11 18.1998 12.19 18.3598 12.35L22.2598 16.25C22.7098 16.7 22.8798 17.36 22.7098 17.97C22.5398 18.58 22.0398 19.05 21.4298 19.19L19.7798 19.58C19.6898 19.6 19.6198 19.67 19.5898 19.77L19.2398 21.24C19.0898 21.89 18.5898 22.39 17.9398 22.54C17.2898 22.7 16.6198 22.47 16.1998 21.96L11.9998 17.13L7.79982 21.97C7.45982 22.37 6.97982 22.59 6.46982 22.59ZM6.08982 14.03L2.79982 17.32C2.70982 17.41 2.71982 17.51 2.73982 17.57C2.74982 17.62 2.79982 17.72 2.91982 17.74L4.56982 18.13C5.21982 18.28 5.71982 18.78 5.86982 19.43L6.21982 20.9C6.24982 21.03 6.34982 21.07 6.40982 21.09C6.46982 21.1 6.56982 21.11 6.65982 21.01L10.4898 16.6C8.78982 16.27 7.22982 15.36 6.08982 14.03ZM13.5098 16.59L17.3398 20.99C17.4298 21.1 17.5398 21.1 17.5998 21.08C17.6598 21.07 17.7498 21.02 17.7898 20.89L18.1398 19.42C18.2898 18.77 18.7898 18.27 19.4398 18.12L21.0898 17.73C21.2098 17.7 21.2598 17.61 21.2698 17.56C21.2898 17.51 21.2998 17.4 21.2098 17.31L17.9198 14.02C16.7698 15.35 15.2198 16.26 13.5098 16.59Z"
            fill="#727A7B"
          />
          <path
            d="M13.8901 12.8903C13.6301 12.8903 13.3201 12.8203 12.9501 12.6003L12.0001 12.0302L11.0501 12.5902C10.1801 13.1102 9.61014 12.8102 9.40014 12.6602C9.19014 12.5102 8.74014 12.0603 8.97014 11.0703L9.21014 10.0403L8.41014 9.30023C7.97014 8.86023 7.81014 8.33025 7.96014 7.85025C8.11014 7.37025 8.55014 7.03024 9.17014 6.93024L10.2401 6.75024L10.7501 5.63025C11.0401 5.06025 11.4901 4.74023 12.0001 4.74023C12.5101 4.74023 12.9701 5.07026 13.2501 5.64026L13.8401 6.82025L14.8301 6.94025C15.4401 7.04025 15.8801 7.38023 16.0401 7.86023C16.1901 8.34023 16.0301 8.87024 15.5901 9.31024L14.7601 10.1403L15.0201 11.0703C15.2501 12.0603 14.8001 12.5102 14.5901 12.6602C14.4801 12.7502 14.2401 12.8903 13.8901 12.8903ZM9.61014 8.39026L10.3001 9.08023C10.6201 9.40023 10.7801 9.94025 10.6801 10.3802L10.4901 11.1802L11.2901 10.7102C11.7201 10.4602 12.3001 10.4602 12.7201 10.7102L13.5201 11.1802L13.3401 10.3802C13.2401 9.93025 13.3901 9.40023 13.7101 9.08023L14.4001 8.39026L13.5301 8.24023C13.1101 8.17023 12.6901 7.86026 12.5001 7.48026L12.0001 6.50024L11.5001 7.50024C11.3201 7.87024 10.9001 8.19025 10.4801 8.26025L9.61014 8.39026Z"
            fill="#727A7B"
          />
        </svg>
      ),
      label: "ABOVE",
      value: "ABOVE",
    },
    {
      icon: (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0001 22.76C10.5201 22.76 9.03005 22.2 7.87005 21.09C4.92005 18.25 1.66005 13.72 2.89005 8.33C4.00005 3.44 8.27005 1.25 12.0001 1.25C12.0001 1.25 12.0001 1.25 12.0101 1.25C15.7401 1.25 20.0101 3.44 21.1201 8.34C22.3401 13.73 19.0801 18.25 16.1301 21.09C14.9701 22.2 13.4801 22.76 12.0001 22.76ZM12.0001 2.75C9.09005 2.75 5.35005 4.3 4.36005 8.66C3.28005 13.37 6.24005 17.43 8.92005 20C10.6501 21.67 13.3601 21.67 15.0901 20C17.7601 17.43 20.7201 13.37 19.6601 8.66C18.6601 4.3 14.9101 2.75 12.0001 2.75Z"
            fill="#727A7B"
          />
          <path
            d="M10.7499 13.7499C10.5599 13.7499 10.3699 13.6799 10.2199 13.5299L8.71994 12.0299C8.42994 11.7399 8.42994 11.2599 8.71994 10.9699C9.00994 10.6799 9.48994 10.6799 9.77994 10.9699L10.7499 11.9399L14.2199 8.46994C14.5099 8.17994 14.9899 8.17994 15.2799 8.46994C15.5699 8.75994 15.5699 9.23994 15.2799 9.52994L11.2799 13.5299C11.1299 13.6799 10.9399 13.7499 10.7499 13.7499Z"
            fill="#727A7B"
          />
        </svg>
      ),
      label: "ADDRESS",
      value:
        props?.data?.contentUserOrgAddresses?.AddressLine1 +
        " " +
        props?.data?.contentUserOrgAddresses?.AddressLine2 +
        " " +
        props?.data?.contentUserOrgAddresses?.Country +
        " " +
        props?.data?.contentUserOrgAddresses?.City +
        " " +
        props?.data?.contentUserOrgAddresses?.State,
    },
  ];

  return (
    <Fragment>
      {props?.userAssessmentDetailsLoading ? (
        <h1 style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', marginTop: '10px' }}>
          Loading ...
        </h1>
      ) : (
        <Fragment>
          <Grid container spacing={3} className="mt-2">
            <Grid item xs={5}>
              <Card
                sx={{
                  backgroundColor: "#e7fbfd",
                  border: "1px solid #e7fbfd",
                  fontSize: "16px",
                  height: "100%",
                }}
              >
                {props.role != 1
                  ? adminFields.map((field, index) => (
                    <UserDetailsRow
                      key={index}
                      icon={field.icon}
                      label={field.label}
                      value={field.value}
                    />
                  ))
                  : userFields.map((field, index) => (
                    <UserDetailsRow
                      key={index}
                      icon={field.icon}
                      label={field.label}
                      value={field.value}
                    />
                  ))}
              </Card>
            </Grid>
            <Grid item xs={7}>
              {props.role != 1 ? (
                <Card
                  sx={{
                    padding: "15px",
                    backgroundColor: "#e7fbfd",
                    border: "1px solid #e7fbfd",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="h6"
                      color={"#727A7B"}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.67998 13.46 7.97998 11.69 7.97998 9.50998C7.97998 7.28998 9.78998 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.46998 8.10998 9.46998 9.49998C9.46998 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z"
                          fill="#727A7B"
                        />
                        <path
                          d="M12 22.7498C9.30996 22.7498 6.73996 21.7498 4.74996 19.9298C4.56996 19.7698 4.48996 19.5298 4.50996 19.2998C4.63996 18.1098 5.37996 16.9998 6.60996 16.1798C9.58996 14.1998 14.42 14.1998 17.39 16.1798C18.62 17.0098 19.36 18.1098 19.49 19.2998C19.52 19.5398 19.43 19.7698 19.25 19.9298C17.26 21.7498 14.69 22.7498 12 22.7498ZM6.07996 19.0998C7.73996 20.4898 9.82996 21.2498 12 21.2498C14.17 21.2498 16.26 20.4898 17.92 19.0998C17.74 18.4898 17.26 17.8998 16.55 17.4198C14.09 15.7798 9.91996 15.7798 7.43996 17.4198C6.72996 17.8998 6.25996 18.4898 6.07996 19.0998Z"
                          fill="#727A7B"
                        />
                        <path
                          d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                          fill="#727A7B"
                        />
                      </svg>
                      <span className="h6"> BIO </span>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{
                        fontSize: "16px",
                        paddingLeft: "13px",
                        paddingRight: "10px",
                        marginLeft: "13px",
                        color: "#000",
                      }}
                    >
                      {props?.data?.contentUserProfile?.BriefBackground
                        ? props?.data?.contentUserProfile?.BriefBackground
                        : "i am a Nutritionist with one goal:to amke healthy living simple"}
                    </Typography>
                  </Box>
                  <hr />
                  <Box>
                    <Typography
                      gutterBottom
                      variant="h6"
                      component="h6"
                      color={"#727A7B"}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.67998 13.46 7.97998 11.69 7.97998 9.50998C7.97998 7.28998 9.78998 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.46998 8.10998 9.46998 9.49998C9.46998 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z"
                          fill="#727A7B"
                        />
                        <path
                          d="M12 22.7498C9.30996 22.7498 6.73996 21.7498 4.74996 19.9298C4.56996 19.7698 4.48996 19.5298 4.50996 19.2998C4.63996 18.1098 5.37996 16.9998 6.60996 16.1798C9.58996 14.1998 14.42 14.1998 17.39 16.1798C18.62 17.0098 19.36 18.1098 19.49 19.2998C19.52 19.5398 19.43 19.7698 19.25 19.9298C17.26 21.7498 14.69 22.7498 12 22.7498ZM6.07996 19.0998C7.73996 20.4898 9.82996 21.2498 12 21.2498C14.17 21.2498 16.26 20.4898 17.92 19.0998C17.74 18.4898 17.26 17.8998 16.55 17.4198C14.09 15.7798 9.91996 15.7798 7.43996 17.4198C6.72996 17.8998 6.25996 18.4898 6.07996 19.0998Z"
                          fill="#727A7B"
                        />
                        <path
                          d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
                          fill="#727A7B"
                        />
                      </svg>
                      <span className="h6"> SOCIAL MEDIA</span>
                    </Typography>
                    <Box
                      className="social-icon-user-details"
                      display="flex"
                      gap={2}
                      marginLeft="20px"
                      color="#000"
                    >
                      <a
                        class="social-icon-link instagram"
                        href={
                          props?.data?.contentUserProfile?.Instagram
                            ? props?.data?.contentUserProfile?.Instagram
                            : "https://www.instagram.com/"
                        }
                        target="_blank"
                        aria-label="instagram"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.0001 29.3332H20.0001C26.6667 29.3332 29.3334 26.6665 29.3334 19.9998V11.9998C29.3334 5.33317 26.6667 2.6665 20.0001 2.6665H12.0001C5.33341 2.6665 2.66675 5.33317 2.66675 11.9998V19.9998C2.66675 26.6665 5.33341 29.3332 12.0001 29.3332Z"
                            stroke="#727A7B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.9999 20.6668C18.5772 20.6668 20.6666 18.5775 20.6666 16.0002C20.6666 13.4228 18.5772 11.3335 15.9999 11.3335C13.4226 11.3335 11.3333 13.4228 11.3333 16.0002C11.3333 18.5775 13.4226 20.6668 15.9999 20.6668Z"
                            stroke="#727A7B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M23.5149 9.33317H23.5303"
                            stroke="#727A7B"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>

                      <a
                        class="social-icon-link youtube"
                        href={
                          props?.data?.contentUserProfile?.YouTube
                            ? props?.data?.contentUserProfile?.YouTube
                            : "https://www.youtube.com/"
                        }
                        target="_blank"
                        aria-label="youtube"
                      >
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M22.6667 26.6668H9.33341C5.33341 26.6668 2.66675 24.0002 2.66675 20.0002V12.0002C2.66675 8.00016 5.33341 5.3335 9.33341 5.3335H22.6667C26.6667 5.3335 29.3334 8.00016 29.3334 12.0002V20.0002C29.3334 24.0002 26.6667 26.6668 22.6667 26.6668Z"
                            stroke="#727A7B"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.2 12.6669L18.5334 14.6669C19.7334 15.4669 19.7334 16.6669 18.5334 17.4669L15.2 19.4669C13.8667 20.2669 12.8 19.6002 12.8 18.1336V14.1336C12.8 12.4002 13.8667 11.8669 15.2 12.6669Z"
                            stroke="#727A7B"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>

                      <a
                        class="social-icon-link mail"
                        href={`mailto:${props?.data?.contentUser?.EmailID
                          }?subject=${"Hello" || ""}&body=${"set body part here" || ""
                          }`}
                        target="_blank"
                        aria-label="mail"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 29 26"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.2442 26H7.75581C2.83256 26 0 23.1622 0 18.2297V8.77027C0 3.83784 2.83256 1 7.75581 1H17.1977C17.7507 1 18.2093 1.45946 18.2093 2.01351C18.2093 2.56757 17.7507 3.02703 17.1977 3.02703H7.75581C3.89814 3.02703 2.02326 4.90541 2.02326 8.77027V18.2297C2.02326 22.0946 3.89814 23.973 7.75581 23.973H21.2442C25.1019 23.973 26.9767 22.0946 26.9767 18.2297V11.473C26.9767 10.9189 27.4353 10.4595 27.9884 10.4595C28.5414 10.4595 29 10.9189 29 11.473V18.2297C29 23.1622 26.1674 26 21.2442 26Z"
                            fill="#727A7B"
                          />
                          <path
                            d="M14.2296 14C13.174 14 12.1058 13.6625 11.2889 12.9746L7.35529 9.72978C6.95313 9.39231 6.87773 8.78228 7.20449 8.36694C7.53124 7.9516 8.12189 7.87372 8.52404 8.21119L12.4576 11.456C13.4128 12.2478 15.0339 12.2478 15.9891 11.456L17.472 10.236C17.8742 9.89851 18.4774 9.9634 18.7916 10.3917C19.1183 10.8071 19.0555 11.4301 18.6408 11.7546L17.1578 12.9746C16.3535 13.6625 15.2853 14 14.2296 14Z"
                            fill="#727A7B"
                          />
                          <path
                            d="M24.5 9C22.0215 9 20 6.97846 20 4.5C20 2.02154 22.0215 0 24.5 0C26.9785 0 29 2.02154 29 4.5C29 6.97846 26.9785 9 24.5 9ZM24.5 2.07692C23.1708 2.07692 22.0769 3.17077 22.0769 4.5C22.0769 5.82923 23.1708 6.92308 24.5 6.92308C25.8292 6.92308 26.9231 5.82923 26.9231 4.5C26.9231 3.17077 25.8292 2.07692 24.5 2.07692Z"
                            fill="#727A7B"
                          />
                        </svg>
                      </a>

                      <a
                        class="social-icon-link twitter"
                        href={
                          props?.data?.contentUserProfile?.Twitter
                            ? props?.data?.contentUserProfile?.Twitter
                            : "https://twitter.com/"
                        }
                        target="_blank"
                        aria-label="twitter"
                      >
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 29 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.6667 7.08532L20.3333 6.75199L21 5.41865L19.3573 5.88532C18.9309 5.48745 18.3972 5.22315 17.8223 5.12506C17.2473 5.02697 16.6562 5.09937 16.1219 5.33333C15.5877 5.56729 15.1336 5.95257 14.8157 6.44162C14.4979 6.93066 14.3302 7.50207 14.3333 8.08532V8.75199C11.974 9.23865 9.91067 7.95199 8 5.75199C7.66667 7.52977 8 8.8631 9 9.75199L7 9.41865C7.27 10.798 7.908 11.8853 9.66667 12.0853L8 12.752C8.66667 14.0853 9.71067 14.292 11.3333 14.4187C10.0713 15.3204 8.55069 15.7883 7 15.752C15.5033 19.5313 20.3333 13.976 20.3333 9.08532V8.19999L21.6667 7.08532Z"
                            stroke="#727A7B"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M21 22.3333H7.66667C3.66667 22.3333 1 19.6667 1 15.6667V7.66667C1 3.66667 3.66667 1 7.66667 1H21C25 1 27.6667 3.66667 27.6667 7.66667V15.6667C27.6667 19.6667 25 22.3333 21 22.3333Z"
                            stroke="#727A7B"
                            stroke-width="1.5"
                            stroke-miterlimit="10"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>

                      <a
                        class="social-icon-link linkedin"
                        href={
                          props?.data?.contentUserProfile?.LinkedIn
                            ? props?.data?.contentUserProfile?.LinkedIn
                            : "https://www.linkedin.com/"
                        }
                        target="_blank"
                        aria-label="linkedin"
                      >
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 29 29"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.3333 20H7V11.55H10.3333V20ZM16.3333 14.15C15.9797 14.15 15.6406 14.287 15.3905 14.5308C15.1405 14.7746 15 15.1052 15 15.45V20H11.6667V11.55H15V12.5152C15.7442 11.9003 16.6846 11.5567 17.66 11.5435C19.6347 11.5435 21 12.9735 21 15.6742V20H17.6667V15.45C17.6667 15.1052 17.5262 14.7746 17.2761 14.5308C17.0261 14.287 16.687 14.15 16.3333 14.15V14.15ZM10.3333 8.625C10.3333 8.94639 10.2356 9.26057 10.0524 9.5278C9.86931 9.79503 9.60902 10.0033 9.30447 10.1263C8.99993 10.2493 8.66482 10.2815 8.34152 10.2188C8.01822 10.1561 7.72124 10.0013 7.48816 9.77405C7.25507 9.54679 7.09633 9.25724 7.03203 8.94202C6.96772 8.6268 7.00072 8.30007 7.12687 8.00314C7.25301 7.70621 7.46664 7.45242 7.74072 7.27386C8.0148 7.0953 8.33703 7 8.66667 7C9.10869 7 9.53262 7.1712 9.84518 7.47595C10.1577 7.7807 10.3333 8.19402 10.3333 8.625Z"
                            stroke="#727A7B"
                            stroke-width="0.666667"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M10.45 28H18.55C25.3 28 28 25.3 28 18.55V10.45C28 3.7 25.3 1 18.55 1H10.45C3.7 1 1 3.7 1 10.45V18.55C1 25.3 3.7 28 10.45 28Z"
                            stroke="#727A7B"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </a>
                    </Box>
                  </Box>
                </Card>
              ) : (
                <Card
                  sx={{
                    backgroundColor: "#e7fbfd",
                    border: "1px solid #e7fbfd",
                    fontSize: "16px",
                    height: "100%",
                  }}
                >
                  <UserAssessmentRow icon={<ViewDataIcon />} label={"View Data"} id={"view"} />
                  <UserAssessmentRow icon={<IconPath.ReceiptLong style={{ color: '#727A7B' }} />} label={"Payment History"} id={"history"} />
                </Card>
              )}
            </Grid>
            {/* <Grid item xs={7}>
        <Card
          sx={{
            backgroundColor: "#0f1c1e",
            padding: "15px",
            border: "1px solid #263234",
          }}
        >
          <Box>
            <Typography
              gutterBottom
              variant="h6"
              component="h6"
              color="#727A7B"
            >
              <span className="h6">BIO</span>
            </Typography>
            <Typography component="p" sx={{ fontSize: "16px", color: "#fff" }}>
              {userProfile?.Bio || "No bio available"}
            </Typography>
          </Box>
        </Card>
      </Grid> */}
          </Grid>
        </Fragment>
      )}
    </Fragment>
  );
});

AboutTab.propTypes = {};
AboutTab.defaultProps = {};

const actionCreators = {
  showDetail,
  userProfileModalToggle,
  modelToggle,
  getAssessmentUserDetails,
};

export default connect(
  ({ user, content }) => ({
    selectedUserData: user.selectedUser,
    selectedUserLoading: user.selectedUserLoading,
    userProfileModal: user.userProfileModalToggle,
    modelToggleData: user.modelToggle,
    userDetailList: user.userDetail,
    userDetailLoading: user.userDetailLoading,
    userAssessmentDetails: user.userAssessmentDetails,
    userAssessmentDetailsLoading: user.userAssessmentDetailsLoading,
  }),
  actionCreators,
  null,
  { forwardRef: true }
)(AboutTab);


const ViewDataIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 465.88 483.88"
    width="22"
    height="22"
  // fill="#727A7B"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M200.77,101.71c.17,57.82-51.53,99.83-101.83,98.92C44.12,199.64-1.12,152.76,0,98,1.11,45.4,49.53-.61,102.74,0,158.94.66,200.5,46.2,200.77,101.71ZM98.19,8.87C66.49,8.63,21,34.06,10.41,81.39c-9.9,44.1,14.8,88.5,57.73,104.86,34.07,13,84.11,1.38,97.79-22.87-1.16-1.07-2.34-2.23-3.58-3.31-21.12-18.39-42.19-36.83-63.42-55.09-3.27-2.81-4.29-5.79-4.09-10,1.24-26.81,2.26-53.62,3.34-80.44C98.25,12.78,98.19,11,98.19,8.87Zm8.77.22a36.15,36.15,0,0,0-.55,3.76c-1.12,27-2.3,53.92-3.17,80.9a9.74,9.74,0,0,0,3.08,6.68c21,18.51,42.17,36.82,63.3,55.17.73.63,1.55,1.15,2.31,1.69,21.31-22.57,27.85-62.11,11.73-96.59C169.26,29.94,132.84,5.25,107,9.09Z" /><path d="M416.76,378.84c-.59,20.5-.78,41-1.95,61.47A104.66,104.66,0,0,1,410,466.72c-4.44,13.6-14.92,19.1-29.07,16.55a86.72,86.72,0,0,1-13.45-3.78c-12-4.28-18.7-13.15-20.1-25.62-.79-7.09-.61-14.3-.57-21.45.14-27.67-.06-55.35.81-83,.49-15.61,2.71-31.17,4.43-46.73a36.54,36.54,0,0,1,2.95-10c3.47-8.24,9.76-13.32,18.77-13.41a105.29,105.29,0,0,1,21.32,2c10.29,2,16.88,9.05,19.27,18.93a124.24,124.24,0,0,1,3.34,25.64c.49,17.65.15,35.33.15,53Zm-21.44-35.78a59.78,59.78,0,0,1,4.75-5.33c5.37-4.74,11.24-9.07,9.43-17.69-.54-2.58-.29-5.32-.67-8-2.61-18.12-7.83-23-26.11-24.51l-2-.16c-12.46-1.09-18.29,2.67-20.37,15.09a277.17,277.17,0,0,0-4.14,38.18c-.91,33.81-1,67.64-1.34,101.46-.05,5.1.66,10.2.91,13.87l9.78,6.17,1.36,1.6c1.26-2,3-3.79,3.67-5.94.61-1.86-.72-5.19.25-5.91,1.48-1.09,4.54.18,6.33-.72,2.91-1.47,5.33-3.89,8-5.9l-1.9-1.21c-.51-2-1-4.05-1.55-6.07l6.43,2.18a12.48,12.48,0,0,1,2.66-2.28,15.23,15.23,0,0,1,3.84-.82,13.53,13.53,0,0,1-.95,3.44,22.93,22.93,0,0,1-2.74,3.27c5.56,7.94,7.08,7.72,13.52-1.17l-15-15.37c-2,.62-4.78.49-5.08-.44-.61-1.89,0-4.23.41-6.34.11-.61,1.24-1.64,1.56-1.53,6.69,2.36,7.33-4.58,11.55-6.61-3.14-3.65-7.59-6.56-8-9.94s3.14-7.43,5.15-11.59a27.88,27.88,0,0,1-3.22-3.63c-.51-.77-.26-2-.36-3.09,1,.11,2.28-.11,3.05.4a39.89,39.89,0,0,1,4.3,3.72l6.8-5.57-5.48-5.24a32.78,32.78,0,0,1-4.18,3.66c-.8.49-2,.26-3.08.36.12-1-.08-2.27.43-3.07a22.93,22.93,0,0,1,3-3.32c.9-2.19-4-6.51,1.05-5.38s5.74-2.11,8.7-4.05l-9.9-9,7.89-9.11Zm12.08,93.58c0-5.23.55-10.43-.26-15.41-.34-2.07-3.45-3.88-5.63-5.31-.55-.36-2.41,1.11-3.58,1.87-2.11,1.35-4.14,2.81-6.31,4.29Zm.15-35.45a24.88,24.88,0,0,1-3.85-2.06c-5.78-4.45-5.76-4.48-10.32,1.88,3.24,3.24,5.16,8.49,11.08,6.75.56,2.38,1,4.39,1.52,6.41l1.57-.29Zm-19,64.22,7.79,8.6,7.09-11C396.26,455.44,396.17,455.46,388.55,465.41Zm5-11.68L388,447.52c-3.45,3-6.38,5.6-9.24,8.12,2.35,2.52,4.21,4.52,6.32,6.77Zm-18.31,5.45-6.95,6.66,6.71,6.25C382.9,465.65,382.9,465.65,375.26,459.18Zm15.84,16.5L385,468.27,379,474.94Zm16.77-114.11c.54-3.61,3-7.22-1.25-10.1L402,355.29Zm1.22-26.89c-2.5,2.63-4.24,4.44-6.46,6.77l6.46,4.62Zm-1.36,62.43V386.3l-5.94,5.64Zm-1.62,51.68-6.23,4.75,4.77,4.31ZM408.27,369l-5,5.33,5,4.76Z" /><path d="M225.3,389.08c-.58,18.14-.79,36.31-1.91,54.43a95.18,95.18,0,0,1-4.52,23.89c-3.88,11.69-12.82,17-25.11,16.28a64,64,0,0,1-13.26-2.24c-17.23-4.88-25.38-15.24-25.21-33.16.34-35,.89-69.94,1.91-104.9a142.66,142.66,0,0,1,4.12-28.11c3.41-14.56,12.64-20.62,27.54-19.23,4.64.43,9.31.8,13.88,1.64,10,1.84,17.27,7.63,20,17.37a93.1,93.1,0,0,1,3.41,22.57c.48,17.14.15,34.3.15,51.45Zm-16.06-60.4-1.11-1.16q-.8-2.64-1.61-5.28a23.51,23.51,0,0,0,4.72,1.09,4.44,4.44,0,0,0,3.32-1.23,5,5,0,0,0,.81-3.87c-1.93-6.36-6.1-10.79-12.68-12.18a131.47,131.47,0,0,0-15.35-2c-9.94-.87-16,2.8-18,12.47-2.12,9.89-3.87,20-4.18,30.11-1,33-1.29,66-1.76,99a48.05,48.05,0,0,0,1,10.92c.67,3.05,2.32,5.88,3.72,9.24l6.4-6a48.87,48.87,0,0,1-4.63-5c-.59-.85-.34-2.29-.47-3.46,1,.2,2.33.08,3.09.65a51.55,51.55,0,0,1,4.45,4.13l8.81-7.65L184,441.94l6.24,1.65,7.71-7.84-5-6.39,1.65.68L207,414.45c-2.14-2-5.07-4.47-7.63-7.27-.87-.95-.83-2.73-1.2-4.13,1.29.41,3,.45,3.79,1.31,2.69,2.91,5.07,6.12,7.37,9,7.41-5.39,10.07-19,6.79-29.15l-4.6,4.89,2.65,6.74-7.41-2.1a21.08,21.08,0,0,1-3.19,2.75c-.8.48-2,.24-3.07.32.13-1,0-2.26.46-3.06a34,34,0,0,1,3.46-4.14c-1.52-1.64-2.87-2.72-3.69-4.12-.54-.92-.34-2.28-.47-3.45,1,.2,2.29.11,3.1.66a44.18,44.18,0,0,1,4.51,4l10.59-10.9c-7-1.65-6.95-1.58-11.47,1.69-.89.65-2.3.58-3.47.85.29-1.28.26-2.78.94-3.8a36.71,36.71,0,0,1,4.07-4.4,19,19,0,0,1-1.71-2.31c-.81-1.6-1.51-3.27-2.25-4.9,1.77.73,3.56,1.43,5.3,2.23a12.74,12.74,0,0,1,1.89,1.28c6.54-4.93,8-9.7,5.66-16.3a60.68,60.68,0,0,1-5.71,4,50.55,50.55,0,0,1-6.09,2.44l3.06-6.89a50.89,50.89,0,0,1-4.65-5c-.6-.8-.3-2.27-.4-3.44,1,.22,2.31.13,3.06.72,1.93,1.5,3.63,3.3,5.34,4.9,8.84-5.35,8.76-10-1.18-16.49a78.56,78.56,0,0,1-5.13,6.3c-.72.73-2.26.66-3.42,1,.26-1.28.1-3,.86-3.77A60.57,60.57,0,0,1,209.24,328.68Zm1.67,137.14c1-2.76,2.07-4.69,2.28-6.71,1.09-10.22,1.8-20.48,2.94-30.69.52-4.6-.79-7.59-5.37-8.74L199,431.5c4.28,3.95,8.52,7.91,12.8,11.82,2.73,2.49,3.22,4.81,0,7.34-2.85,2.24-5.52,4.71-8.47,7.25ZM192.27,447.5l9.25,7.86c2.3-2.67,6.51-5.43,6.79-8.55.23-2.48-4.33-5.4-6.43-7.76Zm-10.83,12.09,7,7.74,8.89-8.18-7.51-8.84Zm10.54,11c5.31,6.66,11.63,5.93,15.92-.88l-6.75-8.21C197.69,465,194.92,467.7,192,470.61Zm-19.68-2.74,0,1.77L187.62,475l.35-1-10.66-10.4Z" /><path d="M188.45,218.36c-15,13.2-29.81,26.15-44.56,39.13q-25,22-49.9,44c-1,.88-1.94,2.2-3.09,2.45-1.59.35-4.24.48-4.83-.38a6,6,0,0,1-.19-5.25c1.08-1.94,3.19-3.34,4.94-4.88Q137.5,252.2,184.19,211c3-2.65,5.5-3.9,9-.55,21.45,20.71,43.06,41.27,64.53,62,7.55,7.28,15,14.66,22.22,22.31,2.77,3,4.74,3.34,7.76.66,16.59-14.67,34.06-28.46,49.72-44.06,20.64-20.57,39.88-42.53,59.71-63.92,1-1.07,1.84-2.29,3.37-4.23-2.5,0-4.2-.12-5.89,0-12.79,1-25.59,2.05-38.38,3.08-1.66.13-3.54.7-4.94.14-1.74-.7-3.1-2.37-4.62-3.62,1.39-1.4,2.55-3.39,4.24-4.06,2.07-.84,4.58-.61,6.91-.8,16.61-1.35,33.24-2.59,49.84-4.08,4.59-.41,6.74,1.19,7.43,5.78,3.14,20.87,1.05,41.58-2,62.23-.23,1.55-3,2.73-4.54,4.09-1.09-1.8-3.19-3.65-3.1-5.38.43-7.81,1.86-15.56,2.21-23.37a182,182,0,0,0-1-28.22c-1,1.14-2.07,2.27-3.08,3.44-28.37,32.57-57.53,64.4-90.29,92.67-8.57,7.4-17.83,14-26.76,20.95-2.82,2.2-5.17,2-7.88-.61-21.94-21.17-44-42.19-66-63.31C204.66,234.43,196.79,226.55,188.45,218.36Z" /><path d="M321.26,412.77c-.66,14.14-1.09,28.29-2.12,42.4a46.87,46.87,0,0,1-3.53,14.44c-3.57,8.56-10.52,13.21-19.74,13.94A66.88,66.88,0,0,1,266,478.83c-9.34-3.64-14.83-10.86-14.65-20.69.52-29.44,1.7-58.88,2.79-88.31.12-3.28,1.15-6.55,2-9.76,3.3-12.1,11-18.2,23.56-18.21A127.06,127.06,0,0,1,297.16,343c16.43,2.28,24.46,11.05,24.94,27.79.4,14,.08,28,.08,41.94ZM312,362.91c-1.81-7-6.06-9.6-11-10.73a99.2,99.2,0,0,0-14.83-1.86c-16.54-1.22-22.53,2.48-23.61,18.77-2,29.69-2.34,59.49-3.14,89.26-.07,2.63,1.63,5.31,2.79,8.8l9.92-9.79a51,51,0,0,1-4.6-5.1c-.48-.69-.06-2-.05-3.07.91.12,2-.06,2.68.41,1.7,1.27,3.19,2.81,5,4.43l7.22-6.67c-2.32-2.44-4.25-4.27-5.9-6.32-.6-.75-.54-2-.78-3.06,1.18.1,2.86-.26,3.44.39a60.43,60.43,0,0,1,4.68,6.46L285.1,443l6.07-1.38c-.63,1.9-1.25,3.8-1.62,4.93l6.63,8.54,10.28-8.31a26.49,26.49,0,0,0-2.58-2.88c-2.55-2-4-6.84-8.71-3.36-.59-.89-1.62-1.76-1.66-2.66s.88-1.94,1.37-2.9a32.11,32.11,0,0,1-3.6-3.91c-.53-.79-.4-2-.57-3.05,1.05.06,2.32-.24,3.09.25a38.72,38.72,0,0,1,4.39,3.73c7.51-5.66,7.51-5.66,1.29-11.9-7.7-7.72-7.7-7.72-.14-15.33a10.41,10.41,0,0,0,2-2.17c.4-.75.74-2.09.35-2.62-3.29-4.51-1.11-7.58,2.24-10.75a5.92,5.92,0,0,0,1.25-4.43c-.21-1.81-1.28-3.53-2-5.28l5.31,2.58c.44.21.89.38,1.3.56,4-2.57,5.57-6.27,4.06-10.43-1-2.79-2.75-3.7-5.19-1.22a42.06,42.06,0,0,1-4.75,4.41,3,3,0,0,1-2.58-.21c-.33-.19-.36-1.67,0-2.21a18.45,18.45,0,0,1,3-3.32c2.23-2,4.28-3.92,1.2-6.92-.41-.41-.13-1.87.27-2.6.17-.32,1.55-.27,2.2,0A31,31,0,0,1,312,362.91ZM306.91,466l1.79-.37c5.3-18.7,2.72-38.08,4.62-56.7l-6.88-3.86-9.63,7.82c3.21,2.72,5.88,4.72,8.25,7,5.84,5.68,5.78,5.72.21,11.38-1.24,1.26-2.39,2.62-3.55,3.9,2.39,4.48,9.11,6.54,7.16,12.08-1.54,4.37-5.29,8-7.94,11.73Zm-41.3,3.84c4.63,1.58,7.95,3.27,11.42,3.65,1.74.19,3.86-1.86,5.54-3.23.44-.37.27-2.3-.28-2.93-2.13-2.44-4.53-4.64-6.85-6.94C272.18,463.54,269.47,466.15,265.61,469.87Zm20,3.34c6.55,4.08,15.29,2.28,19.17-2.68l-8-9.23c-1.75,4.32-8.39,4.86-4.76,10.77a8.45,8.45,0,0,1-2.88,1.78C288,474.06,286.8,473.46,285.62,473.21Zm1.08-7.67,6.31-5.86-7.23-9.31c-3,2.61-5.21,4.54-7.75,6.75Zm27.18-75-1.5-1.58c-2.37,1.62-4.81,3.15-7.05,4.93-.58.45-.56,1.66-.82,2.52a27.35,27.35,0,0,0,3,.05c1.05-.09,2.1-.36,3.15-.55a15.05,15.05,0,0,0-.27,3.51,30.46,30.46,0,0,0,1.25,4.43l1.63-.5Z" /><path d="M128.21,417.6c-.68,13.3-1.11,26.63-2.1,39.91-1.35,17.91-11.28,27.05-29.17,26-8.36-.48-16.77-2.45-24.88-4.72-8.78-2.46-13.94-9.21-13.78-18.2.46-25.94,1.51-51.87,2.66-77.79.17-3.87,1.8-7.77,3.24-11.46,3.38-8.61,9.93-13.49,19.12-13.61a137.16,137.16,0,0,1,23.88,1.53c14.58,2.37,21.62,11,21.87,25.84.19,10.82,0,21.64,0,32.45Zm-12.35-46c-7.15-5.26-14.46-5.07-21.53-5.55-18.77-1.28-25,3.28-26.07,22.06-1.43,23.93-1.57,47.94-1.92,71.92,0,2.91,2,5.84,3.13,8.89,4.08-2,4.25-3.7,1.83-5.84a18.31,18.31,0,0,1-3.11-3.24,8.88,8.88,0,0,1-.76-3c1.17.09,2.65-.24,3.46.35a75.33,75.33,0,0,1,6.36,5.86c1.26-1.3,2.34-2.4,3.55-3.63a39.16,39.16,0,0,1-4-4.59c-.49-.8-.28-2-.39-3.07,1,.12,2.29-.07,3.1.43a42.06,42.06,0,0,1,4.69,4c2.8-3.73,5.21-7,7.69-10.19a5.56,5.56,0,0,1,2-1.83c4.27-1.74,7.2-4.43,7-10.27,7.63,3,10.79,10.39,16.89,14,3-8.85,2-11.92-4.35-15.66l-6.9,2.46c.84-2.27,1.67-4.54,2.64-7.2-.43-.51-1.15-1.41-1.92-2.26-4.11-4.5-4.08-6.07.17-10.42,1.93-2,3.79-4,4.91-5.2-.87-3-1.44-5-2-7.05l6.86,2.44c1-1.07,2.47-2.69,3.95-4.32l-.78-1.15c-3,.43-5.62-3.76-8.81-.2-.73-.8-2.07-1.63-2-2.4a4.45,4.45,0,0,1,1.12-2.28l-2.11-6.65,7.15,1.95,2.9-3.07c-3-2.34-4-7.6-9.27-4.17-.24.15-2-1.4-1.93-1.5a62.1,62.1,0,0,1,4.51-6.8C112.71,373.44,114.1,372.85,115.86,371.63ZM95.09,469.26c2.16,1.51,4.06,2.61,5.69,4,2.83,2.45,7.69,1.81,11-1.5s-.16-4.88-1.86-6.75-3.51-3.35-5.67-5.38C101.39,462.6,98.92,465.21,95.09,469.26Zm6.4-12.75L95.39,451l-8.49,7.6,6,6.54c1.73-1.65,3-2.87,4.31-4.13S99.69,458.39,101.49,456.51Zm14.17,8c3.86-8.08,3.39-10.38-2.7-13.53l-5.16,5.46Zm-1.44-38c1.78-2.66,3.69-4.71,4.58-7.13.61-1.62-.21-3.77-.39-5.69-1.63.29-3.45.22-4.83,1-2.17,1.15-4,2.86-6.82,4.89C109.52,422.15,111,423.56,114.22,426.53Zm-9.86,28.32c2.36-3.64,4.67-5.83,5-8.31.19-1.31-3.1-4.48-4.64-4.36-2,.14-5.34,2.87-5.24,4.29C99.69,448.9,102.08,451.18,104.36,454.85ZM86.17,472.93c1.14-2.31,3-4.41,2.51-5.45a11.42,11.42,0,0,0-4.87-4.6c-.6-.33-2.4,1.51-3.91,2.54Z" /><path d="M354.67,52Q303,52,251.22,52c-3.17,0-7.66.95-7.69-3.94s4.37-4.1,7.61-4.1q103.71,0,207.41,0c1.33,0,3-.34,3.92.29,1.47,1,3.47,2.68,3.41,4s-2.22,3-3.81,3.59-3.61.22-5.44.22Z" /><path d="M319.52,113.78q-37.26,0-74.53,0c-1.66,0-3.57.37-4.92-.31a5.93,5.93,0,0,1-3-3.81c-.14-1.1,1.44-2.92,2.69-3.54s3.25-.45,4.91-.45q74.78,0,149.56,0c1,0,2.22-.35,3,.1,1.79,1.07,4.46,2.29,4.77,3.86.62,3.08-2,4.15-4.85,4.16q-16.51,0-33,0Q341.78,113.8,319.52,113.78Z" /><path d="M42.67,48.85c3.63-3.43,6.8-6.61,10.2-9.51.9-.77,2.53-.68,3.82-1-.38,1.27-.45,2.77-1.2,3.76a28.27,28.27,0,0,1-4.32,4.14c-3.79,3.21-7.05,6.35-1.83,11.16.73.68.3,2.62.4,4a16.3,16.3,0,0,1-3.58-1.75c-1.11-.91-1.88-2.23-3.51-4.24-2.88,3.77-5.58,7-7.86,10.54-.43.66.8,2.4,1.29,3.63s1,2.52,1.56,3.79c-1.43-.26-2.87-.46-4.28-.79A15.36,15.36,0,0,1,31,71.49l-4.58,9.59,5.36,4.75-7.34,1.92c-.23,3.93-.51,8.72-.79,13.68a67.53,67.53,0,0,1,7.76.71c.82.17,1.41,1.45,2.1,2.23-.77.5-1.51,1.35-2.33,1.44-1.91.21-3.86.07-7.13.07,1.8,5.67,3.11,10.41,4.93,14.94.35.87,2.69,1,4.13,1.39s2.92.8,4.39,1.19c-1.14.93-2.25,1.91-3.44,2.76a13.12,13.12,0,0,1-2.51,1c1.94,3.69,2.92,8.66,5.77,10.24,3.87,2.15,6.27,3.33,4.33,8-.24.59,1.09,1.69,1.23,2.62a7.36,7.36,0,0,1-.61,2.65c-.87-.28-2.26-.3-2.54-.87-1.86-3.71-4.18-4.83-7.86-2.25-.51.36-1.9-.53-2.89-.84.38-.84.54-1.92,1.17-2.47a31.6,31.6,0,0,1,4.16-2.66c-2-3.92-3.8-7.83-6.06-11.43-.5-.81-2.67-.58-4.07-.82l-3.53-.6c.62-1,1-2.6,1.9-3,3-1.36,2.62-3.2,1.63-5.68-1.12-2.77-1.84-5.7-2.72-8.56-.24-.8-.31-2.23-.69-2.31-6.9-1.53-2.1-4.15-1.36-7.32,1.15-4.87.31-10.2.31-16.21a34.42,34.42,0,0,1-4-1.52,2.38,2.38,0,0,1-1.16-1.91c.07-.58,1.22-1.6,1.58-1.48,7.3,2.43,7.29-4,9.43-7.72.65-1.13,1.08-2.38,1.87-4.17A44.93,44.93,0,0,1,22,66.46c-.82-.49-1.21-1.68-1.79-2.55,1-.38,2.33-1.38,2.87-1,6.13,3.78,8.9-.12,12.13-4.54,2.66-3.65,6-6.55.39-10.32-.47-.32-.2-1.74-.28-2.65,1,0,2.25-.25,3.07.19A32.34,32.34,0,0,1,42.67,48.85Z" />
      </g>
    </g>
  </svg>
)